export default "__VITE_ASSET__DNNkeFEl__"